import { Instagram, Heart } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

const FALLBACK = [
  "/brand/valentina-editorial.jpg",
  "/brand/valentina-close.jpg",
  "/brand/national-director-winner.jpg",
  "/brand/jury-panel.jpg",
  "/brand/taufiq-sash.jpg",
  "/brand/taufiq-beach.jpg",
];

export default function InstagramFeed({ feed, instagramUrl }) {
  const posts = feed?.data || [];
  const items = posts.length
    ? posts.map((p) => ({
        src: p.media_type === "VIDEO" ? p.thumbnail_url : p.media_url,
        href: p.permalink,
        caption: p.caption,
        live: true,
      }))
    : FALLBACK.map((src) => ({ src, href: instagramUrl, caption: null, live: false }));

  return (
    <section id="instagram" data-testid="instagram-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <SectionHeading kicker="Follow the Reign" title="@valentina.mishra on Instagram" testid="instagram-heading" align="center" />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {items.slice(0, 6).map((item, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <a
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-item-${i}`}
              className="group relative block aspect-square overflow-hidden border border-white/10 transition-colors duration-500 hover:border-[#D4AF37]/60"
            >
              <img
                src={item.src}
                alt={item.caption ? item.caption.slice(0, 80) : "D'La Valentina on Instagram"}
                loading="lazy"
                className="h-full w-full bg-black object-contain transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-500 group-hover:bg-black/60">
                <Instagram className="h-7 w-7 text-[#D4AF37] opacity-0 transition-opacity duration-500 group-hover:opacity-100" strokeWidth={1} />
              </div>
              {item.live && (
                <span className="absolute left-2 top-2 flex items-center gap-1 bg-black/70 px-2 py-1 text-[9px] uppercase tracking-widest text-[#D4AF37]">
                  <Heart className="h-3 w-3" strokeWidth={1.5} /> Live
                </span>
              )}
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-12 text-center">
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="inline-flex items-center gap-3 border border-[#D4AF37]/60 px-10 py-4 text-xs uppercase tracking-[0.3em] text-[#D4AF37] transition-all duration-300 hover:bg-[#D4AF37] hover:text-black"
        >
          <Instagram className="h-4 w-4" strokeWidth={1.5} /> Follow @valentina.mishra
        </a>
      </Reveal>
    </section>
  );
}
